import i18n from '../i18n'

/**
 * 后端返回的中文提示 → i18n key（apiMsg 命名空间）
 *
 * TP8 后端的 error('...') 全部返回中文 msg，前端如果直接把 res.msg 弹给用户，
 * 非中文环境就会看到中文报错。这里在 axios 响应拦截器里统一翻译一次，
 * 所有页面读到的 res.msg 都已经是当前语言，不需要逐个组件改。
 *
 * 新增后端提示时：在 CN_TO_KEY 里补一行映射，并在 6 个语言包的 apiMsg 下补文案。
 */
const CN_TO_KEY = {
  // ---------- 登录 / 账号 ----------
  '用户不存在': 'userNotFound',
  '密码错误': 'wrongPassword',
  '账号已被禁用': 'accountDisabled',
  '坐席账号不存在': 'agentNotFound',
  '坐席已被禁用': 'agentDisabled',
  '未登录': 'notLogin',
  'Token已过期': 'tokenExpired',
  'Token无效': 'tokenExpired',
  'Token格式错误': 'tokenExpired',
  'Token已失效，请重新登录': 'tokenExpired',

  // ---------- 表单校验 ----------
  '请输入邮箱': 'emailRequired',
  '邮箱格式不正确': 'emailInvalid',
  '邮箱和密码不能为空': 'emailPasswordRequired',
  '账号和密码不能为空': 'accountPasswordRequired',
  '坐席账号和密码不能为空': 'agentAccountRequired',
  '密码至少6位': 'passwordMin',
  '新密码至少6位': 'newPasswordMin',
  '该邮箱已被注册': 'emailExists',
  '邮箱已被注册': 'emailExists',
  '用户名已存在': 'usernameExists',
  '验证码错误': 'captchaWrong',
  '验证码已过期，请重新获取': 'captchaExpired',
  '请填写完整信息': 'paramIncomplete',
  '参数错误': 'paramError',
  '参数不完整': 'paramIncomplete',
  '缺少ID': 'missingId',
  '没有需要更新的字段': 'nothingToUpdate',
  '状态值无效': 'invalidStatus',
  '索引超出范围': 'indexOutOfRange',

  // ---------- 渠道 / 客服 ----------
  '缺少渠道码': 'missingChannelCode',
  '渠道不存在': 'channelNotFound',
  '渠道已关闭': 'channelClosed',
  '该会员暂未开通客服渠道': 'noChatChannel',
  '该商户客服套餐已过期，暂时无法使用': 'chatPlanExpired',
  '当前暂无坐席在线，请稍后再试': 'noAgentOnlineRetry',
  '目标坐席不存在或未启用': 'targetAgentInvalid',
  '坐席不存在或无权操作': 'agentNoOperate',
  '会话不存在': 'sessionNotFound',
  '会话不匹配': 'sessionMismatch',
  '无权转接该会话': 'noPermissionTransfer',
  '无权结束该会话': 'noPermissionClose',
  '无权删除该会话': 'noPermissionDelete',
  '该会话有聊天记录，无法删除': 'chatHasHistory',
  '客户在线，无法删除': 'clientOnline',
  '只能撤回客服消息': 'onlyAgentRecall',

  // ---------- 充值 / 业务 ----------
  '余额不足': 'balanceInsufficient',
  '余额不足，扣减后余额将为负数': 'balanceInsufficient',
  '充值金额至少1美元': 'rechargeMinAmount',
  '订单不存在': 'orderNotFound',
  '该订单已取消': 'orderCancelled',
  '该订单已确认到账': 'orderConfirmed',
  '该订单不是待支付状态，无法取消': 'orderNotPayable',
  '该订单不是待支付状态，无法确认': 'orderNotPayable',
  '套餐不存在': 'planNotFound',
  '服务不存在': 'serviceNotFound',
  '文章不存在': 'articleNotFound',
  '号码不可用': 'numberUnavailable',
  '暂无可用号码': 'noAvailableNumber',
  '号码已存在': 'numberExists',
  '租用记录不存在': 'rentalNotFound'
}

/**
 * 前缀匹配：后端把动态内容拼在中文后面的提示
 */
const PREFIX_TO_KEY = [
  ['已达套餐坐席数上限', 'agentLimitReached'],
  ['邮件发送失败', 'emailSendFailed']
]

/**
 * 把后端中文提示翻译成当前语言；中文环境或未知文案原样返回
 * @param {string} msg 后端返回的 msg
 * @returns {string}
 */
export function translateApiMsg(msg) {
  if (!msg || typeof msg !== 'string') return msg
  if (!i18n || i18n.locale === 'zh') return msg

  const key = CN_TO_KEY[msg]
  if (key) return i18n.t('apiMsg.' + key)

  for (let i = 0; i < PREFIX_TO_KEY.length; i++) {
    const prefix = PREFIX_TO_KEY[i][0]
    if (msg.indexOf(prefix) === 0) return i18n.t('apiMsg.' + PREFIX_TO_KEY[i][1])
  }

  return msg
}

export default translateApiMsg
